var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.66675 11C3.04549 11 2.73487 11 2.48983 10.8985C2.16313 10.7632 1.90357 10.5036 1.76824 10.1769C1.66675 9.93187 1.66675 9.62127 1.66675 9C1.66675 8.37873 1.66675 8.06813 1.76824 7.82307C1.90357 7.4964 2.16313 7.2368 2.48983 7.10147C2.73487 7 3.04549 7 3.66675 7C4.288 7 4.59863 7 4.84366 7.10147C5.17036 7.2368 5.42993 7.4964 5.56525 7.82307C5.66675 8.06813 5.66675 8.37873 5.66675 9C5.66675 9.62127 5.66675 9.93187 5.56525 10.1769C5.42993 10.5036 5.17036 10.7632 4.84366 10.8985C4.59863 11 4.288 11 3.66675 11Z",
    fill: "#141B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.3335 7C9.71223 7 9.40163 7 9.15656 6.89853C8.8299 6.7632 8.5703 6.5036 8.43496 6.17693C8.3335 5.93187 8.3335 5.62125 8.3335 5C8.3335 4.37875 8.3335 4.06812 8.43496 3.82309C8.5703 3.49639 8.8299 3.23682 9.15656 3.10149C9.40163 3 9.71223 3 10.3335 3C10.9548 3 11.2654 3 11.5104 3.10149C11.8371 3.23682 12.0967 3.49639 12.232 3.82309C12.3335 4.06812 12.3335 4.37875 12.3335 5C12.3335 5.62125 12.3335 5.93187 12.232 6.17693C12.0967 6.5036 11.8371 6.7632 11.5104 6.89853C11.2654 7 10.9548 7 10.3335 7Z",
    fill: "#141B34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 13V11",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 13V9",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 3V1",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 5V1",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 11C3.04549 11 2.73487 11 2.48983 10.8985C2.16313 10.7632 1.90357 10.5036 1.76824 10.1769C1.66675 9.93187 1.66675 9.62127 1.66675 9C1.66675 8.37873 1.66675 8.06813 1.76824 7.82307C1.90357 7.4964 2.16313 7.2368 2.48983 7.10147C2.73487 7 3.04549 7 3.66675 7C4.288 7 4.59863 7 4.84366 7.10147C5.17036 7.2368 5.42993 7.4964 5.56525 7.82307C5.66675 8.06813 5.66675 8.37873 5.66675 9C5.66675 9.62127 5.66675 9.93187 5.56525 10.1769C5.42993 10.5036 5.17036 10.7632 4.84366 10.8985C4.59863 11 4.288 11 3.66675 11Z",
    stroke: "#A1A4AE",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 7C9.71223 7 9.40163 7 9.15656 6.89853C8.8299 6.7632 8.5703 6.5036 8.43496 6.17693C8.3335 5.93187 8.3335 5.62125 8.3335 5C8.3335 4.37875 8.3335 4.06812 8.43496 3.82309C8.5703 3.49639 8.8299 3.23682 9.15656 3.10149C9.40163 3 9.71223 3 10.3335 3C10.9548 3 11.2654 3 11.5104 3.10149C11.8371 3.23682 12.0967 3.49639 12.232 3.82309C12.3335 4.06812 12.3335 4.37875 12.3335 5C12.3335 5.62125 12.3335 5.93187 12.232 6.17693C12.0967 6.5036 11.8371 6.7632 11.5104 6.89853C11.2654 7 10.9548 7 10.3335 7Z",
    stroke: "#A1A4AE",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.db9f130c442e9071c4943543c772ca0a.svg";
export { ForwardRef as ReactComponent };